import axios from 'axios'
import { getToken, removeToken } from '../utils/auth'
import { Loading, Message } from 'element-ui'
import { NOT_FOUND, UNAUTHORIZED, INTERNAL_SERVER_ERROR } from '../utils/const'
import router from '../router'

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    }
});

// ローディング
let loadingInstance;

httpClient.interceptors.request.use(config => {
  loadingInstance = Loading.service({ fullscreen: true })
  return config
})

httpClient.interceptors.response.use(response => {
  loadingInstance.close()
  return response
})

// エラーハンドリング
httpClient.interceptors.response.use(null, error => {
  loadingInstance.close()

  let errorMessage = ''

  switch (error.response.status) {
    case NOT_FOUND:

      errorMessage = error.response.data.message || 'エラーが発生しました'

      Message({
          message: errorMessage + ' 3秒後に一覧画面に戻ります',
          type: 'error'
      })

      setTimeout(() => {
        router.push({ name: 'top' })
      }, 3000);

      break

    case INTERNAL_SERVER_ERROR:
      Message({
          message: 'システムエラーが発生しました',
          type: 'error'
      })
      break

    case UNAUTHORIZED:
      removeToken()
      break

    default:
      break;
  }

  return Promise.reject(error);
})


const authInterceptor = (config) => {
    config.headers['Authorization'] = `Bearer ${getToken()}`
    return config
}


httpClient.interceptors.request.use(authInterceptor)

httpClient.interceptors.response.use()

export default httpClient;